/**
 * GİRİŞ EKRANINA NEDEN DÖNÜLDÜ
 *
 * ================================================================
 * ÜÇ AYRI YOL, TEK VE SESSİZ SONUÇ
 * ================================================================
 * Ölçüldü (05.09.2026): öğrenci giriş ekranına **üç** yoldan
 * dönebiliyor ve üçünde de ekran **hiçbir şey söylemiyordu** —
 * öğrenci kendini birden giriş formunda buluyordu:
 *
 *   `Uygulama.tsx:201/222`  sunucu 401 verdi (oturum bitti)
 *   `Uygulama.tsx:504`      öğrenci kendi çıkış yaptı
 *
 * `CikisYapildi.dc.html` çizimi bunun için ayrı bir ekran istiyor ve
 * **iki şey** söylüyor: yerel verilerin temizlendiğini, ve öteki
 * cihazlardaki oturumların açık kaldığını. `OturumSuresiDoldu.dc.html`
 * da oturumun neden kapandığını söylüyor.
 *
 * ================================================================
 * SÜRE YAZILMIYOR — BİLEREK
 * ================================================================
 * Çizim *"45 dakika"* diyor; yapılandırmada personel 30, öğrenci
 * 10080 dakika — yani çizimin sayısı **hiçbirini** tutmuyor. Dahası
 * güvenlik konsolu (F-SEC-03) bu süreleri çalışma anında
 * ayarlanabilir yapıyor. Ekrana gömülen bir sayı, gömüldüğü gün
 * eskiyecek.
 *
 * Sebep süreye bağlı değil: "oturumun kapandı" cümlesi süre değişse
 * de doğru kalıyor.
 */

export type GirisSebebi = "cikis" | "oturum";

/**
 * Giriş ekranının üstünde gösterilecek cümle; sebep yoksa `null`.
 *
 * ÇIKIŞTA İKİ ŞEY SÖYLENİYOR ve ikisi de çizimden:
 *
 *   - **bu cihazdaki veriler temizlendi** — doğru, `Uygulama.tsx`
 *     çıkışta çevrimdışı okuma önbelleğini de düşürüyor
 *     (`okumaOnbellegiTemizle`). Aynı telefonu kullanan ikinci
 *     öğrencinin birincinin programını okuyamaması bu sayede.
 *   - **öteki cihazlar açık kalır** — çıkış yapan kişi çoğu zaman
 *     "başkası hesabıma girmiş olabilir" diye çıkış yapıyor ve
 *     yalnızca bu cihazın kapandığını bilmesi gerekiyor. Bilmezse
 *     kendini güvende sanır.
 */
export function girisSebebiCumlesi(sebep: GirisSebebi | null): string | null {
  if (sebep === "cikis") {
    return (
      "Çıkış yaptınız. Bu cihazdaki verileriniz temizlendi — " +
      "başka cihazlardaki oturumlarınız açık kalmaya devam eder."
    );
  }
  if (sebep === "oturum") {
    return "Oturumunuz kapandı. Devam etmek için yeniden giriş yapmanız gerekiyor.";
  }
  return null;
}
